import {
  LOGIN,
  AUTH_SET_LOADING,
  SINGLE_USER,
  LOGINAGAIN,
  FORGET_LOADER,
} from "../types";
import firebase from "../../config/firebase";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import UserRepository from "../../repository/UserRepository";
import { parsePhoneNumber } from "libphonenumber-js";
const provider = new firebase.auth.GoogleAuthProvider();
let cartPath = localStorage.getItem("cartPath");

export const signupLoader = (val) => async (dispatch) => {
  dispatch({
    type: AUTH_SET_LOADING,
    payload: val,
  });
};

export const signUpAction = (payload, onSuccess) => async (dispatch) => {
  dispatch(signupLoader(true));
  firebase
    .firestore()
    .collection("users")
    .where("email", "==", payload.email)
    .get()
    .then((querySnapshot) => {
      if (!querySnapshot.empty) {
        dispatch(signupLoader(false));
        toast.error("A user with this email already exists.");
        return;
      }
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((data) => {
          firebase
            .firestore()
            .collection("users")
            .doc(data.user.uid)
            .set({
              name: payload.name,
              email: payload.email,
              onetimelogin: true,
              contactNumber: payload.contactNumber,
              type: "customer",
              gender: payload.gender,
              age: payload.age,
              DOB: payload?.DOB,
              address: payload?.address || "",
              imageURL: "",
              createdAt: firebase.firestore.Timestamp.now(),
            })
            .then(() => {
              dispatch(signupLoader(false));
              UserRepository.addNewUser({ email: payload.email })
                .then(() => {
                  toast.success("Sign up successful");
                  toast.success("Verification email has been sent!");
                })
                .catch((error) => {
                  toast.error(
                    error.response?.data?.message ||
                      "Failed to send verification email."
                  );
                });

              onSuccess();
            })
            .catch((err) => {
              dispatch(signupLoader(false));
              toast.error(err.message);
            });
        })
        .catch((err) => {
          dispatch(signupLoader(false));
          if (err.code === "auth/email-already-in-use") {
            toast.error("Email is already in use. Please try logging in.");
          } else {
            toast.error(err.message);
          }
        });
    })
    .catch((err) => {
      dispatch(signupLoader(false));
      toast.error("Error checking existing users: " + err.message);
    });
};

export const signInAction = (payload, onSuccess) => async (dispatch) => {
  dispatch(signupLoader(true));
  try {
    dispatch(signupLoader(true));
    await firebase
      .auth()
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then((userCredential) => {
        var uid = userCredential.user.uid;
        var user = userCredential.user;
        if (user.emailVerified) {
          firebase
            .firestore()
            .collection("users")
            .doc(uid)
            .onSnapshot(async (query) => {
              if (query.data()?.type === "customer") {
                if (query.data().isDeleted) {
                  toast.warning(
                    "Your account data have been deleted from database. But the good news is, your account is still alive. Please contact your admin to create a new slot for you to store data then you will be able to login."
                  );
                } else {
                  dispatch({
                    type: LOGIN,
                    payload: {
                      uid: uid,
                      user: { id: uid, ...query.data() },
                    },
                  });
                  onSuccess();
                  dispatch(signupLoader(false));
                }
              } else {
                toast.error("This User does not Exist");
                dispatch(signupLoader(false));
              }
            });
        } else {
          throw new Error("Email Verification is not verified!");
        }
      })
      .catch((err) => {
        dispatch(signupLoader(false));
        toast.error("Invalid Credentials! Please try again");
      });
  } catch (error) {
    dispatch(signupLoader(false));
    toast(error.message);
  }
};
export const signInWithGoogle = (history, isGoogle) => async (dispatch) => {
  firebase
    .auth()
    .signInWithPopup(provider)
    .then((result) => {
      const uid = result?.user?.uid;
      firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .onSnapshot(async (query) => {
          if (query.data()?.type === "customer") {
            if (query.data().isDeleted) {
              toast.warning(
                "Your account data have been deleted from database. But the good news is, your account is still alive. Please contact your admin to create a new slot for you to store data then you will be able to login."
              );
            } else {
              dispatch({
                type: LOGIN,
                payload: {
                  uid: uid,
                  user: { id: uid, ...query.data() },
                },
              });
              {
                isGoogle
                  ? history.push(`/cart`)
                  : cartPath
                  ? history.push("/cart")
                  : history.push(`/restaurants`);
              }
            }
          } else {
            firebase
              .firestore()
              .collection("users")
              .doc(uid)
              .set({
                imageURL: "",
                name: result?.user?.displayName,
                email: result?.user?.email,
                type: "customer",
                createdAt: firebase.firestore.Timestamp.now(),
              })
              .then((res) => {
                toast.success("sign up successfully");
                history.push("/restauarants");
              });
          }
        });
    })
    .catch((error) => {
      // handle authentication error
    });
};

export const logoutAction = () => async (dispatch) => {
  firebase
    .auth()
    .signOut()
    .then((data) => {
      localStorage.clear();
      window.location.href = "/main";
    })
    .catch((error) => {});
};

export const getSingleUser = (id) => async (dispatch) => {
  try {
    dispatch(singleUserLoader(false));
    await firebase
      .firestore()
      .collection("users")
      .doc(id)
      .get()
      .then((res) => {
        dispatch({
          type: SINGLE_USER,
          payload: {
            id: id,
            ...res.data(),
          },
        });
      });
    dispatch(singleUserLoader(false));
  } catch (err) {
    console.error(err.message);
    dispatch(singleUserLoader(false));
  }
};

export const updateProfileImageAction = (payload) => async (dispatch) => {
  dispatch(signupLoader(true));
  try {
    if (!payload?.image?.name) {
      toast.error("No image file selected");
      dispatch(signupLoader(false));
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (payload.image.size > maxSize) {
      toast.error("Image size must be less than 5MB");
      dispatch(signupLoader(false));
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(payload.image.type)) {
      toast.error("Please select a valid image file (JPEG, PNG, GIF, or WebP)");
      dispatch(signupLoader(false));
      return;
    }

    let docData = await firebase
      .firestore()
      .collection("users")
      .doc(payload?.id)
      .get();

    if (!docData.exists) {
      toast.error("User not found");
      dispatch(signupLoader(false));
      return;
    }

    if (docData.data()?.imageURL && docData.data().imageURL !== "") {
      try {
        await firebase.storage().refFromURL(docData.data().imageURL).delete();
      } catch (deleteError) {
        console.warn("Could not delete old image:", deleteError.message);
      }
    }

    let fileName = payload?.image?.name;
    let fileExtension = fileName?.slice(fileName.lastIndexOf("."));
    let uniqueFileName = `profile_images/${uuidv4()}${fileExtension?.toLowerCase()}`;

    let storageRef = firebase.storage().ref(uniqueFileName);
    let uploadTask = await storageRef.put(payload?.image);
    
    if (uploadTask.state !== 'success') {
      throw new Error("Upload failed");
    }

    let downloadURL = await uploadTask.ref.getDownloadURL();

    await firebase
      .firestore()
      .collection("users")
      .doc(payload.id)
      .update({
        imageURL: downloadURL,
      });

    dispatch(getSingleUser(payload.id));
    
    toast.success("Profile image updated successfully!");
    dispatch(signupLoader(false));
    
  } catch (err) {
    console.error("Image upload error:", err);
    toast.error(err.message || "Failed to upload image. Please try again.");
    dispatch(signupLoader(false));
  }
};

export const updateProfileAction =
  (payload, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(signupLoader(true));
    try {
      await firebase
        .firestore()
        .collection("users")
        .doc(payload.id)
        .update({
          ...payload,
          onetimelogin: false,
        })
        .then(() => {
          toast.success("Profile updated successfully!");
          dispatch({
            type: LOGINAGAIN,
          });
          dispatch(getSingleUser(payload.id));
          dispatch(signupLoader(false));
          onSuccess();
        })
        .catch((e) => {
          toast.error(e.message);
          dispatch(signupLoader(false));
        });
    } catch (err) {
      toast.error(err.message);
    }
  };
export const updateUserAction = (payload, onSuccess) => async (dispatch) => {
  try {
    await firebase
      .firestore()
      .collection("users")
      .doc(payload.id)
      .update({
        ...payload,
      })
      .then(() => {
        onSuccess();
      })
      .catch((e) => {
        toast.error(e.message);
      });
  } catch (err) {
    toast.error(err.message);
  }
};
export const updateThemeAction = (payload) => async (dispatch) => {
  try {
    firebase
      .firestore()
      .collection("users")
      .doc(payload.id)
      .update({
        ...payload,
      })
      .then(() => {
        dispatch(getSingleUser(payload.id));
        dispatch({
          type: "DARKMODE",
          payload: payload.darkMode,
        });
      })
      .catch((e) => {
        toast.error(e.message);
      });
  } catch (err) {
    toast.error(err.message);
  }
};
// export const updateColorAction = (payload) => async (dispatch) => {
//     try {
//         firebase
//             .firestore()
//             .collection("users")
//             .doc(payload.id)
//             .update({
//                 ...payload,
//             })
//             .then(() => {
//                 dispatch(getSingleUser(payload.id));
//                 dispatch({
//                     type: "COLOR",
//                     payload: payload.mainColor,
//                 });
//             })
//             .catch((e) => {
//                 alert(e.message);
//             });
//     } catch (err) {
//         alert(err.message);
//     }
// };

export const forgetPassword =
  (email, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(forgetLoader(true));
    try {
      await UserRepository.forgetPassword({ email });
      dispatch(forgetLoader(false));
      toast.success("Please check your email and reset the password");
      onSuccess();
    } catch (error) {
      dispatch(forgetLoader(false));
      toast.error(error.response?.data?.message || error.message);
    }
  };

const forgetLoader = (data) => async (dispatch) => {
  dispatch({
    type: FORGET_LOADER,
    payload: data,
  });
};

const singleUserLoader = (data) => async (dispatch) => {
  dispatch({
    type: "SINGLE_USER_LOADER",
    payload: data,
  });
};

export const sendPhoneOTP =
  (phoneNumber, recaptchaVerifier) => async (dispatch) => {
    dispatch(signupLoader(true));
    try {
      const formattedPhone = parsePhoneNumber(phoneNumber, "US").format(
        "E.164"
      );
      const confirmationResult = await firebase
        .auth()
        .signInWithPhoneNumber(formattedPhone, recaptchaVerifier);
      dispatch(signupLoader(false));
      return { success: true, confirmationResult };
    } catch (error) {
      dispatch(signupLoader(false));
      console.error("Error sending OTP:", error);

      if (error.code === "auth/too-many-requests") {
        toast.error("Too many requests. Please try again later.");
      } else if (error.code === "auth/invalid-phone-number") {
        toast.error("Invalid phone number format");
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
      return { success: false, error };
    }
  };

export const verifyPhoneOTP =
  (confirmationResult, otp, phoneNumber, onSuccess) => async (dispatch) => {
    dispatch(signupLoader(true));
    try {
      const result = await confirmationResult.confirm(otp);
      const user = result.user;

      const userDoc = await firebase
        .firestore()
        .collection("users")
        .doc(user.uid)
        .get();

      if (!userDoc.exists) {
        const formattedPhone = parsePhoneNumber(
          phoneNumber,
          "US"
        ).formatInternational();
        await firebase.firestore().collection("users").doc(user.uid).set({
          name: "",
          email: "",
          contactNumber: formattedPhone,
          type: "customer",
          onetimelogin: true,
          createdAt: firebase.firestore.Timestamp.now(),
          imageURL: "",
          address: "",
          gender: "",
          age: "",
          DOB: "",
        });
        toast.success("Account created successfully!");
      }

      const updatedUserDoc = await firebase
        .firestore()
        .collection("users")
        .doc(user.uid)
        .get();
      const userData = updatedUserDoc.data();

      if (userData?.type === "customer") {
        if (userData.isDeleted) {
          toast.warning("Your account has been deleted. Please contact admin.");
          dispatch(signupLoader(false));
          return { success: false };
        } else {
          dispatch({
            type: LOGIN,
            payload: {
              uid: user.uid,
              user: { id: user.uid, ...userData },
            },
          });

          toast.success("Login successful!");
          onSuccess();
          dispatch(signupLoader(false));
          return { success: true };
        }
      } else {
        toast.error("Invalid user type");
        dispatch(signupLoader(false));
        return { success: false };
      }
    } catch (error) {
      dispatch(signupLoader(false));
      console.error("Error verifying OTP:", error);

      if (error.code === "auth/invalid-verification-code") {
        toast.error("Invalid OTP. Please check and try again.");
      } else if (error.code === "auth/code-expired") {
        toast.error("OTP has expired. Please request a new one.");
      } else {
        toast.error("Verification failed. Please try again.");
      }
      return { success: false, error };
    }
  };
